var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "c-search-loading" }, [
      _c("div", { staticClass: "c-search-loading__inner" }, [
        _c("div", {
          staticClass: "c-search-loading__rect c-search-loading__rect--one"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "c-search-loading__rect c-search-loading__rect--two"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "c-search-loading__rect c-search-loading__rect--three"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "c-search-loading__rect c-search-loading__rect--four"
        }),
        _vm._v(" "),
        _c("div", {
          staticClass: "c-search-loading__rect c-search-loading__rect--five"
        })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3b48a012", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b48a012","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/results/SearchLoading.vue
// module id = 602
// module chunks = 0